import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import { UnBlockRequestModel } from 'Pages/orders'

export const unblockRequestApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<UnBlockRequestModel>>(
			`${urls.orders.unBlockRequest}`,
			{ params }
		)
		return res.data
	},
	confirm: async (id: number, comment: string) => {
		const res = await axiosDS().patch(`${urls.orders.unBlockRequest}/${id}/confirm`, {
			data: { comment },
		})
		return res.data
	},
	decline: async (id: number, comment: string) => {
		const res = await axiosDS().patch(`${urls.orders.unBlockRequest}/${id}/decline`, {
			data: { comment },
		})
		return res.data
	},
	clarify: async (id: number, comment: string) => {
		const res = await axiosDS().patch(`${urls.orders.unBlockRequest}/${id}/clarify`, {
			data: { comment },
		})
		return res.data
	},
	backToChecking: async (id: number, data: any) => {
		const res = await axiosDS().patch(`${urls.orders.unBlockRequest}/${id}/back_to_checking`, {
			data,
		})
		return res.data
	},
	getOne: async (id: number) => {
		const res = await axiosDS().get<UnBlockRequestModel>(`${urls.orders.unBlockRequest}/${id}`)
		return res.data
	},
	setStatusAgreement: async (id: string, status: string) => {
		const res = await axiosDS().patch(
			urls.partnerRequest.set_status_agremeent.replace(':id', id).replace(':status', status),
			{ status }
		)
		return res.data
	},
}
